import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteHeroCtaFragment = contentfulGql`#graphql
  fragment EntWebsiteHeroCta on EntWebsiteHeroCta {
    ctaTarget
    ctaText
  }
`;

export const entWebsiteProofPointFragment = contentfulGql`#graphql
  fragment EntWebsiteProofPoint on EntWebsiteProofPoint {
    title
    slug
    keyMetric
    unit
    description
    footnote
  }
`;

export const entWebsiteHeroContentFragment = contentfulGql`#graphql
  ${entWebsiteHeroCtaFragment}
  ${entWebsiteProofPointFragment}
  fragment EntWebsiteHeroContent on EntWebsiteHeroContent {
    tabLabel
    heroContentDisplayStyle
    bulletPoints
    paragraph
    subCtaText
    primaryCta{
        ...EntWebsiteHeroCta
    }
    secondaryCta{
        ...EntWebsiteHeroCta    
    }
  }
`;

export const entWebsiteHeroFragment = contentfulGql`#graphql
  ${entWebsiteHeroContentFragment}
  fragment EntWebsiteHero on EntWebsiteHero {
    slug
    headline
    eyebrow
    image{
        ...Image
    }
    primaryHeroContent{
        ...EntWebsiteHeroContent
    }
    secondaryHeroContent{
        ...EntWebsiteHeroContent
    }
    selectedTab
    proofPointsCollection {
      items {
        ...EntWebsiteProofPoint
      }
    }
  }
`;

export const entWebsiteBlockHeroQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteHeroFragment}
  ${imageFragment}
  query entWebsiteBlockHero($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteHero
      }
    }
  }
`;
